// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forecast-form-container {
  max-width: 700px;
  margin: 40px auto;
  padding: 25px;
  border: 1px solid #ddd;
  border-radius: 12px;
  background-color: #ffffff;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

.forecast-form h2 {
  text-align: center;
  margin-bottom: 20px;
  color: #111111;
  font-size: 24px;
  font-weight: bold;
}

.form-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.form-group {
  flex: 1 1;
  margin: 0 10px;
  display: flex;
  flex-direction: column;
}

.form-group label {
  margin-bottom: 5px;
  font-weight: 600;
  font-size: 14px;
  color: #333;
}

.form-group input {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  background-color: #f9f9f9;
}

.form-group input::placeholder {
  font-size: 12px;
  color: #aaa;
}

.submit-button {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  text-align: center; /* Center the button */
  margin-top: 10px;
  background-color: #1976d2;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-button:hover {
  background-color: #1565c0;
}

.error-message {
  color: red;
  text-align: center;
  margin-top: 15px;
}

.forecast-result {
  margin-top: 30px;
  background-color: #eef6ff;
  padding: 20px;
  border-radius: 8px;
}

/* Spinner */
.loading-message {
  text-align: center;
  margin-top: 20px;
  color: #333; /* Darker text for waiting message */
}

.spinner {
  margin: 0 auto 10px;
  width: 50px;
  height: 50px;
  border: 6px solid #ccc;
  border-top: 6px solid #1976d2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ===================== */
/* Forecast Table Styling */
/* ===================== */

.forecast-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background-color: #ffffff;
}

.forecast-table th,
.forecast-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
  color: #333; /* Dark text */
  font-size: 14px;
}

/* Fix the header */
.forecast-table thead {
  background-color: #1976d2;
  color: white;
}

.forecast-table thead th {
  position: sticky;
  top: 0;
  background-color: #1976d2;
  z-index: 1;
}

/* Scrollable body */
.forecast-table tbody {
  display: block;
  max-height: 300px; /* Scrollable height */
  overflow-y: auto;
  width: 100%;
}

.forecast-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

/* Row background alternate */
.forecast-table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.forecast-table tbody tr:nth-child(odd) {
  background-color: #ffffff;
}

.forecast-table tbody tr:hover {
  background-color: #e6f2ff;
}
`, "",{"version":3,"sources":["webpack://./src/ForecastForm.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,kBAAkB,EAAE,sBAAsB;EAC1C,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW,EAAE,oCAAoC;AACnD;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,0BAA0B;AAC1B,2BAA2B;AAC3B,0BAA0B;;AAE1B;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,WAAW,EAAE,cAAc;EAC3B,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,yBAAyB;EACzB,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,iBAAiB,EAAE,sBAAsB;EACzC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".forecast-form-container {\n  max-width: 700px;\n  margin: 40px auto;\n  padding: 25px;\n  border: 1px solid #ddd;\n  border-radius: 12px;\n  background-color: #ffffff;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);\n}\n\n.forecast-form h2 {\n  text-align: center;\n  margin-bottom: 20px;\n  color: #111111;\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.form-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 15px;\n}\n\n.form-group {\n  flex: 1;\n  margin: 0 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group label {\n  margin-bottom: 5px;\n  font-weight: 600;\n  font-size: 14px;\n  color: #333;\n}\n\n.form-group input {\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 14px;\n  background-color: #f9f9f9;\n}\n\n.form-group input::placeholder {\n  font-size: 12px;\n  color: #aaa;\n}\n\n.submit-button {\n  width: 100%;\n  padding: 12px;\n  font-size: 16px;\n  text-align: center; /* Center the button */\n  margin-top: 10px;\n  background-color: #1976d2;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.submit-button:hover {\n  background-color: #1565c0;\n}\n\n.error-message {\n  color: red;\n  text-align: center;\n  margin-top: 15px;\n}\n\n.forecast-result {\n  margin-top: 30px;\n  background-color: #eef6ff;\n  padding: 20px;\n  border-radius: 8px;\n}\n\n/* Spinner */\n.loading-message {\n  text-align: center;\n  margin-top: 20px;\n  color: #333; /* Darker text for waiting message */\n}\n\n.spinner {\n  margin: 0 auto 10px;\n  width: 50px;\n  height: 50px;\n  border: 6px solid #ccc;\n  border-top: 6px solid #1976d2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ===================== */\n/* Forecast Table Styling */\n/* ===================== */\n\n.forecast-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n  background-color: #ffffff;\n}\n\n.forecast-table th,\n.forecast-table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: center;\n  color: #333; /* Dark text */\n  font-size: 14px;\n}\n\n/* Fix the header */\n.forecast-table thead {\n  background-color: #1976d2;\n  color: white;\n}\n\n.forecast-table thead th {\n  position: sticky;\n  top: 0;\n  background-color: #1976d2;\n  z-index: 1;\n}\n\n/* Scrollable body */\n.forecast-table tbody {\n  display: block;\n  max-height: 300px; /* Scrollable height */\n  overflow-y: auto;\n  width: 100%;\n}\n\n.forecast-table tbody tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\n\n/* Row background alternate */\n.forecast-table tbody tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.forecast-table tbody tr:nth-child(odd) {\n  background-color: #ffffff;\n}\n\n.forecast-table tbody tr:hover {\n  background-color: #e6f2ff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
